const noContext = {
    extracted: true,
    window: undefined,
    document: undefined,
    DOMNode: undefined,
    DOMElement: undefined,
};
export function extractDOMContext(ctx) {
    if (ctx && ctx.extracted) {
        return ctx;
    }
    if (!ctx || !ctx.window)
        return noContext;
    const w = ctx.window;
    return {
        window: ctx.window,
        document: ctx.document || ctx.window.document,
        DOMNode: w.Node,
        DOMElement: w.Element,
    };
}
export function isDOMNode(ctx, obj) {
    return ctx && ctx.DOMNode && (obj instanceof ctx.DOMNode) || false;
}
export function isDOMElement(ctx, obj) {
    return ctx && ctx.DOMElement && (obj instanceof ctx.DOMElement) || false;
}
//# sourceMappingURL=context.mjs.map